<script>
import MainLayout from '../layouts/mainLayout'
import googleMap from '@/components/googleMap'
import {DateUtil} from '@/utils/date.js'
import MovementDetailedConfirm from '@/components/MovementDetailedConfirm'
import dialog from '@/components/Dialog'
import MovementShiftWindowMask from '@/components/MovementShiftWindowMask'

import STATION_ICON_1 from '../../assets/map_icon/map_stop_point1.png'
import USER_ICON_1 from '../../assets/map_icon/map_transit_point1.png'
import STATION_ICON_2 from '../../assets/map_icon/map_stop_point2.png'
import USER_ICON_2 from '../../assets/map_icon/map_transit_point2.png'
import STATION_NO_ICON_1 from '../../assets/map_icon/map_non_stop_point1.png'
import STATION_NO_ICON_2 from '../../assets/map_icon/map_non_stop_point2.png'
// var houseIndex = 1
export default {
  beforeMount () {
    this.beforeMountFunc()
    // let shiftId = this.$route.query.shiftId

    // this.$axios.get('shift/queryShiftInfoDetail', {params: {shiftId: shiftId}})
    //   .then(response => {
    //     this.shiftInfo = response.data.shiftInfo
    //     this.driverNameTitle = this.shiftInfo.driverName + '(スケジュール)'
    //     this.currentDate = this.shiftInfo.moveShiftTime
    //     this.shiftInfo.useTime = this.shiftInfo.moveShiftTime
    //     this.tmpMoveShiftTime = this.shiftInfo.moveShiftTime
    //     this.shiftInfo.moveShiftTime = DateUtil.yearWeek(this.shiftInfo.moveShiftTime)
    //     let shiftPasspoints = this.shiftInfo.shiftPasspoints
    //     let sps = []
    //     // 业务结束使用灰色图标
    //     if (this.shiftInfo.businessStatus === 3) {
    //       this.stationIcon = STATION_ICON_2
    //       this.userIcon = USER_ICON_2
    //       this.noStopIcon = STATION_NO_ICON_2
    //       this.labelClass = 'station-label-class-2'
    //     } else {
    //       this.stationIcon = STATION_ICON_1
    //       this.userIcon = USER_ICON_1
    //       this.noStopIcon = STATION_NO_ICON_1
    //       this.labelClass = 'station-label-class-1'
    //     }
    //     if (shiftPasspoints.length !== 0) {
    //       let stopObj = this.isStop(shiftPasspoints[0].stationId)

    //       let startPassengers = stopObj.startPassengers
    //       let arrivePassengers = stopObj.arrivePassengers
    //       let startPointPassengers = stopObj.startPassengers
    //       let arrivePointPassengers = stopObj.arrivePassengers
    //       let showPassengers = false
    //       if (startPassengers.length > 0) {
    //         showPassengers = true
    //       }
    //       // 添加起始S
    //       sps.push(
    //         {
    //           listIndex: 'S',
    //           // 便の详细的路的序号
    //           index: 'S',
    //           estimateTime: shiftPasspoints[0].startEstimateTime !== null ? shiftPasspoints[0].startEstimateTime : this.shiftInfo.startEstimateTimeSlot,
    //           name: shiftPasspoints[0].stationName,
    //           address: shiftPasspoints[0].address,
    //           actualTime: shiftPasspoints[0].arriveActualTime,
    //           stopFlag: true,
    //           routeType: shiftPasspoints[0].routeType,
    //           stationId: shiftPasspoints[0].stationId,
    //           stationLat: shiftPasspoints[0].stationLat,
    //           stationLng: shiftPasspoints[0].stationLng,
    //           passengerNameKana: '',
    //           reserveId: '',
    //           startPassengers: startPassengers,
    //           arrivePassengers: arrivePassengers,
    //           showPassengers: showPassengers,
    //           icon: this.stationIcon,
    //           stationNote: shiftPasspoints[0].stationNote,
    //           // 该点所有上车人
    //           startPointPassengers: startPointPassengers,
    //           // 该点所有下车人
    //           arrivePointPassengers: arrivePointPassengers,
    //           labelClass: this.labelClass
    //         }
    //       )
    //       // 一般情况
    //       let listIndex = -1
    //       let houselistIndex = 0
    //       let houseIndex = 0
    //       let gIndex = 0
    //       // 已经到达点的标记
    //       let arriveK = -1
    //       for (let shiftPasspoint of shiftPasspoints) {
    //         listIndex++
    //         // 找到到达点
    //         if (shiftPasspoint.arriveActualTime) {
    //           arriveK = listIndex
    //         }
    //         if (listIndex === 0) continue
    //         let splistIndex = ''
    //         let spIndex = ''
    //         if (listIndex === shiftPasspoints.length - 1) {
    //           spIndex = splistIndex = 'G'
    //         } else if (shiftPasspoint.routeType === '0') {
    //           spIndex = 'G' + (++gIndex)
    //         } else {
    //           spIndex = '' + (++houseIndex)
    //         }

    //         let name = ''
    //         let nameKana = ''
    //         let addressObj = null
    //         let stopFlag = false
    //         // 停留所的上下车人
    //         let startPassengers = []
    //         let arrivePassengers = []
    //         // 上下车人
    //         let startPointPassengers = []
    //         let arrivePointPassengers = []
    //         // note
    //         let note = ''

    //         if (shiftPasspoint.routeType === '1') {
    //           let nameObj = this.getPassengerNameObj(shiftPasspoint.reserveId)
    //           name = nameObj.name
    //           nameKana = nameObj.nameKana
    //           note = nameObj.reservationNote
    //           // estimateTime = nameObj.estimateTime
    //           addressObj = this.getPassengerAddressObj(shiftPasspoint.reserveId)
    //           stopFlag = true
    //           if (this.shiftInfo.shiftFlag === 0) {
    //             startPointPassengers.push({reserveId: shiftPasspoint.reserveId, name: name})
    //           } else {
    //             arrivePointPassengers.push({reserveId: shiftPasspoint.reserveId, name: name})
    //           }
    //         } else {
    //           // estimateTime = shiftPasspoint.arriveEstimateTime !== null ? shiftPasspoint.arriveEstimateTime : this.shiftInfo.arriveEstimateTimeSlot
    //           name = shiftPasspoint.stationName
    //           note = shiftPasspoint.stationNote
    //           addressObj = {address: shiftPasspoint.address, stationId: shiftPasspoint.stationId, lat: shiftPasspoint.stationLat, lng: shiftPasspoint.stationLng}
    //           let stopObj = this.isStop(shiftPasspoint.stationId)
    //           stopFlag = stopObj.stopFlag
    //           startPassengers = stopObj.startPassengers
    //           arrivePassengers = stopObj.arrivePassengers
    //           startPointPassengers = stopObj.startPassengers
    //           arrivePointPassengers = stopObj.arrivePassengers
    //         }
    //         if (listIndex === shiftPasspoints.length - 1) {
    //           stopFlag = true
    //         }

    //         if (!splistIndex && stopFlag) {
    //           splistIndex = '' + (++houselistIndex)
    //         }

    //         let showPassengers = false
    //         if (shiftPasspoint.routeType === '0' && stopFlag && startPassengers.length > 0) {
    //           showPassengers = true
    //         }

    //         let icon = ''
    //         if (stopFlag === true) {
    //           icon = shiftPasspoint.routeType === '0' ? this.stationIcon : this.userIcon
    //         } else {
    //           icon = this.noStopIcon
    //         }
    //         sps.push(
    //           {
    //             listIndex: splistIndex,
    //             index: spIndex,
    //             estimateTime: shiftPasspoint.arriveEstimateTime !== null ? shiftPasspoint.arriveEstimateTime : this.shiftInfo.arriveEstimateTimeSlot,
    //             name: name,
    //             address: addressObj.address,
    //             actualTime: shiftPasspoint.arriveActualTime,
    //             stopFlag: stopFlag,
    //             routeType: shiftPasspoint.routeType,
    //             stationId: addressObj.stationId,
    //             stationLat: addressObj.lat,
    //             stationLng: addressObj.lng,
    //             passengerNameKana: nameKana,
    //             reserveId: shiftPasspoint.reserveId,
    //             startPassengers: startPassengers,
    //             arrivePassengers: arrivePassengers,
    //             showPassengers: showPassengers,
    //             icon: icon,
    //             stationNote: note,
    //             startPointPassengers: startPointPassengers,
    //             arrivePointPassengers: arrivePointPassengers,
    //             labelClass: this.labelClass
    //           }
    //         )
    //       }
    //       // 设置点的样式
    //       for (let i = 0; i <= arriveK; i++) {
    //         if (sps[i].icon === this.stationIcon) {
    //           sps[i].icon = STATION_ICON_2
    //         } else if (sps[i].icon === this.userIcon) {
    //           sps[i].icon = USER_ICON_2
    //         } else {
    //           sps[i].icon = STATION_NO_ICON_2
    //         }
    //         sps[i].labelClass = 'station-label-class-2'
    //       }
    //     }

    //     this.shiftPasspoints = sps

    //     this.shiftConnectList = []
    //     for(let i = 0; i < this.shiftPasspoints.length; i++){
    //       this.shiftPasspoints[i].connectList = []
    //     }
    //     this.setConnectList()
        
    //     let passPoints = []
    //     let noStopPoints = []
    //     // 画点
    //     new Promise((resolve, reject) => {
    //       // let st = 1
    //       for (let shiftPasspoint of this.shiftPasspoints) {
    //         if (shiftPasspoint.stopFlag === true) {
    //           // st += 1
    //           this.pointDataList.push({
    //             stationId: shiftPasspoint.listIndex,
    //             stationLat: shiftPasspoint.stationLat,
    //             stationLng: shiftPasspoint.stationLng,
    //             icon: shiftPasspoint.icon,
    //             labelClass: shiftPasspoint.labelClass
    //           })
    //         } else {
    //           noStopPoints.push({
    //             shiftId: null,
    //             label: null,
    //             lat: shiftPasspoint.stationLat,
    //             lng: shiftPasspoint.stationLng,
    //             // 点的图标
    //             icon: shiftPasspoint.icon,
    //             iconSize: {
    //               width: 20,
    //               height: 20
    //             }
    //           })
    //         }
    //         passPoints.push({
    //           lat: shiftPasspoint.stationLat,
    //           lng: shiftPasspoint.stationLng
    //         })
    //       }
    //       resolve()
    //     }).then(() => {
    //       this.$refs.gMap.initializeGoogleMap().then(() => {
    //         this.$refs.gMap.map.setZoom(14)
    //         this.centerPoint = {
    //           lat: (this.pointDataList[0].stationLat + this.pointDataList[this.pointDataList.length - 1].stationLat) / 2,
    //           lng: (this.pointDataList[0].stationLng + this.pointDataList[this.pointDataList.length - 1].stationLng) / 2
    //         }
    //         this.$refs.gMap.map.setCenter(this.centerPoint)
    //         let imgSize = {width: 45, height: 60}
    //         let labelAnchor = {width: 22, height: 50}
    //         this.$refs.gMap.addMark(imgSize, this.labelClass, labelAnchor)
    //         for (let noStopPoint of noStopPoints) {
    //           this.$refs.gMap.addSingleMaker(noStopPoint)
    //         }
    //         // this.$refs.gMap.drawLine(passPoints)
    //         this.$refs.gMap.plannRoute(passPoints)
    //         // })
    //       })
    //     })
    //     // 存入Session中
    //     sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    // this.$axios.get('shift/selectInfoName').then(response => {
    //   sessionStorage.setItem('userInfo', JSON.stringify(response.data.userInfo))
    // })
  },
  data () {
    return {
      functionId: 'MovementShiftDetail',
      mapId: 'mapMovementShiftDetail',
      // 地图中心点
      centerPoint: {
        lat: 35.699,
        lng: 139.730
      },
      // 停留所ICON
      stationIcon: null,
      // 自宅地图选ICON
      userIcon: null,
      // 未停車ICON
      noStopIcon: null,
      // label样式
      labelClass: null,
      // 地图标记点List
      pointDataList: [],
      shiftInfo: {
        shiftReservationInfos: [],
        shiftPasspoints: [
          {
            startEstimateTime: '',
            stationName: '',
            address: '',
            arriveActualTime: ''
          }
        ],
        useTime: ''
      },
      // 临时存放yyyyMMdd格式的日期
      tmpMoveShiftTime: '',
      shiftMovementStatus: [
        '未公開',
        '公開中',
        '業務中',
        '業務終了',
        '強制終了'
      ],
      // ドライバー全员、单人 便详细运行状况状态局部不一样
      shiftMovementStatus1: [
        '業務予定',
        '業務中',
        '業務終了',
        '業務未定',
        '強制終了'
      ],
      shiftReservation: {
        flag: 'add'
      },
      shiftPasspoints: [],
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: 'この予約はキャンセル待ちとなります<br/>予約を続けますか?',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      showMessDialog: false,
      dialogMessOption: {
        showNo: false,
        text: 'この便は予約されました。非公開できません。',
        confirmButtonText: 'OK'
      },
      // backName: this.$route.query.from === 'MovementShift' ? '運行便一覧に戻る' : '車両リストに戻る',
      backName: this.$route.query.from === 'MovementShift' ? '運行便一覧に戻る' : (this.$route.query.from === 'VehicleList' ? '車両リストに戻る' : 'スケジュール一覧に戻る'),
      currentDate: '',
      // 状态背景
      statusBtnBgs: [
        // 非公开
        'status-btn-bg2',
        // 公开中
        'status-btn-bg1',
        // 运行中
        'status-btn-bg3',
        // 终了
        'status-btn-bg3',
        // 强制终了
        'status-btn-bg3'
      ],
      // title背景,顺序如上
      titleBgs: [
        'bgc13',
        'bgc1',
        'bgc4',
        'bgc9',
        'bgc9'
      ],
      // 内容背景,顺序如上
      contentBgs: [
        'bgc7',
        'bgc7',
        'bgc7',
        'bgc2',
        'bgc2'
      ],
      shiftDetail: {},
      driverNameTitle: '',
      // 接続一覧
      shiftConnectList: [],
      // 接続されているすべての便が編集可能かどうか true:可能
      allConnectShiftsCanEdit: true
    }
  },
  mounted () {
  },
  computed: {
    shiftStatus () {
      let status = 0
      // 获取shift的状态
      status = this.checkStatus(this.shiftInfo)
      return status
    },
    showReservationDiv () {
      // let now = new Date()

      // let shiftDate = DateUtil.shortStringToDate(this.tmpMoveShiftTime)
      // let shiftTime = shiftDate.getTime() - 7 * 3600 * 1000

      if (this.shiftInfo.businessStatus === 1 && this.shiftInfo.openFlag === 1 && this.allConnectShiftsCanEdit) {
        return true
      } else {
        return false
      }
    }
  },
  components: {MainLayout, googleMap, MovementDetailedConfirm, 'v-dialog': dialog, MovementShiftWindowMask},
  watch: {
    '$route'(to,from){
      this.beforeMountFunc()
    }
  },
  methods: {
    beforeMountFunc () {
      let shiftId = this.$route.query.shiftId

      this.$axios.get('shift/queryShiftInfoDetail', {params: {shiftId: shiftId}})
        .then(response => {
          this.shiftInfo = response.data.shiftInfo
          console.log('shift/queryShiftInfoDetail')
          console.log(this.shiftInfo)
          this.driverNameTitle = this.shiftInfo.driverName + '(スケジュール)'
          this.currentDate = this.shiftInfo.moveShiftTime
          this.shiftInfo.useTime = this.shiftInfo.moveShiftTime
          this.tmpMoveShiftTime = this.shiftInfo.moveShiftTime
          this.shiftInfo.moveShiftTime = DateUtil.yearWeek(this.shiftInfo.moveShiftTime)
          let shiftPasspoints = this.shiftInfo.shiftPasspoints
          let sps = []
          // 业务结束使用灰色图标
          if (this.shiftInfo.businessStatus === 3) {
            this.stationIcon = STATION_ICON_2
            this.userIcon = USER_ICON_2
            this.noStopIcon = STATION_NO_ICON_2
            this.labelClass = 'station-label-class-2'
          } else {
            this.stationIcon = STATION_ICON_1
            this.userIcon = USER_ICON_1
            this.noStopIcon = STATION_NO_ICON_1
            this.labelClass = 'station-label-class-1'
          }
          if (shiftPasspoints.length !== 0) {
            let stopObj = this.isStop(shiftPasspoints[0].stationId)

            let startPassengers = stopObj.startPassengers
            let arrivePassengers = stopObj.arrivePassengers
            let startPointPassengers = stopObj.startPassengers
            let arrivePointPassengers = stopObj.arrivePassengers
            let showPassengers = false
            if (startPassengers.length > 0) {
              showPassengers = true
            }
            // 添加起始S
            sps.push(
              {
                listIndex: 'S',
                // 便の详细的路的序号
                index: 'S',
                estimateTime: shiftPasspoints[0].startEstimateTime !== null ? shiftPasspoints[0].startEstimateTime : this.shiftInfo.startEstimateTimeSlot,
                name: shiftPasspoints[0].stationName,
                address: shiftPasspoints[0].address,
                actualTime: shiftPasspoints[0].arriveActualTime,
                stopFlag: true,
                routeType: shiftPasspoints[0].routeType,
                stationId: shiftPasspoints[0].stationId,
                displayStationId: shiftPasspoints[0].displayStationId,
                stationLat: shiftPasspoints[0].stationLat,
                stationLng: shiftPasspoints[0].stationLng,
                passengerNameKana: '',
                reserveId: '',
                startPassengers: startPassengers,
                arrivePassengers: arrivePassengers,
                showPassengers: showPassengers,
                icon: this.stationIcon,
                stationNote: shiftPasspoints[0].stationNote,
                // 该点所有上车人
                startPointPassengers: startPointPassengers,
                // 该点所有下车人
                arrivePointPassengers: arrivePointPassengers,
                labelClass: this.labelClass,
                officeFlag: shiftPasspoints[0].officeFlag,
                displayFlag: shiftPasspoints[0].displayFlag
              }
            )
            // 一般情况
            let listIndex = -1
            let houselistIndex = 0
            let houseIndex = 0
            let gIndex = 0
            // 已经到达点的标记
            let arriveK = -1
            for (let shiftPasspoint of shiftPasspoints) {
              listIndex++
              // 找到到达点
              if (shiftPasspoint.arriveActualTime) {
                arriveK = listIndex
              }
              if (listIndex === 0) continue
              let splistIndex = ''
              let spIndex = ''
              if (listIndex === shiftPasspoints.length - 1) {
                spIndex = splistIndex = 'G'
              } else if (shiftPasspoint.routeType === '0') {
                spIndex = 'G' + (++gIndex)
              } else {
                spIndex = '' + (++houseIndex)
              }

              let name = ''
              let nameKana = ''
              let addressObj = null
              let stopFlag = false
              // 停留所的上下车人
              let startPassengers = []
              let arrivePassengers = []
              // 上下车人
              let startPointPassengers = []
              let arrivePointPassengers = []
              // note
              let note = ''

              if (shiftPasspoint.routeType === '1') {
                let nameObj = this.getPassengerNameObj(shiftPasspoint.reserveId)
                name = nameObj.name
                nameKana = nameObj.nameKana
                note = nameObj.reservationNote
                // estimateTime = nameObj.estimateTime
                addressObj = this.getPassengerAddressObj(shiftPasspoint.reserveId)
                stopFlag = true
                addressObj.displayFlag = shiftPasspoint.displayFlag
                if (this.shiftInfo.shiftFlag === 0) {
                  startPointPassengers.push({reserveId: shiftPasspoint.reserveId, name: name})
                } else {
                  arrivePointPassengers.push({reserveId: shiftPasspoint.reserveId, name: name})
                }
              } else {
                // estimateTime = shiftPasspoint.arriveEstimateTime !== null ? shiftPasspoint.arriveEstimateTime : this.shiftInfo.arriveEstimateTimeSlot
                name = shiftPasspoint.stationName
                note = shiftPasspoint.stationNote
                addressObj = {address: shiftPasspoint.address, stationId: shiftPasspoint.stationId, lat: shiftPasspoint.stationLat, lng: shiftPasspoint.stationLng, officeFlag: shiftPasspoint.officeFlag, displayFlag: shiftPasspoint.displayFlag}
                let stopObj = this.isStop(shiftPasspoint.stationId)
                stopFlag = stopObj.stopFlag
                startPassengers = stopObj.startPassengers
                arrivePassengers = stopObj.arrivePassengers
                startPointPassengers = stopObj.startPassengers
                arrivePointPassengers = stopObj.arrivePassengers
              }
              if (listIndex === shiftPasspoints.length - 1) {
                stopFlag = true
              }

              if (!splistIndex && stopFlag && shiftPasspoint.displayFlag === 1) {
                splistIndex = '' + (++houselistIndex)
              }

              let showPassengers = false
              if (shiftPasspoint.routeType === '0' && stopFlag && startPassengers.length > 0 && shiftPasspoint.displayFlag === 1) {
                showPassengers = true
              }

              let icon = ''
              if (stopFlag === true && shiftPasspoint.displayFlag === 1) {
                icon = shiftPasspoint.routeType === '0' ? this.stationIcon : this.userIcon
              } else {
                icon = this.noStopIcon
              }
              sps.push(
                {
                  listIndex: splistIndex,
                  index: spIndex,
                  estimateTime: shiftPasspoint.arriveEstimateTime !== null ? shiftPasspoint.arriveEstimateTime : this.shiftInfo.arriveEstimateTimeSlot,
                  name: name,
                  address: addressObj.address,
                  actualTime: shiftPasspoint.arriveActualTime,
                  stopFlag: stopFlag,
                  routeType: shiftPasspoint.routeType,
                  stationId: addressObj.stationId,
                  displayStationId: shiftPasspoint.displayStationId,
                  stationLat: addressObj.lat,
                  stationLng: addressObj.lng,
                  passengerNameKana: nameKana,
                  reserveId: shiftPasspoint.reserveId,
                  startPassengers: startPassengers,
                  arrivePassengers: arrivePassengers,
                  showPassengers: showPassengers,
                  icon: icon,
                  stationNote: note,
                  startPointPassengers: startPointPassengers,
                  arrivePointPassengers: arrivePointPassengers,
                  labelClass: this.labelClass,
                  officeFlag: addressObj.officeFlag,
                  displayFlag: addressObj.displayFlag
                }
              )
            }
            // 设置点的样式
            for (let i = 0; i <= arriveK; i++) {
              if (sps[i].icon === this.stationIcon) {
                sps[i].icon = STATION_ICON_2
              } else if (sps[i].icon === this.userIcon) {
                sps[i].icon = USER_ICON_2
              } else {
                sps[i].icon = STATION_NO_ICON_2
              }
              sps[i].labelClass = 'station-label-class-2'
            }
          }

          this.shiftPasspoints = sps

          this.shiftConnectList = []
          for(let i = 0; i < this.shiftPasspoints.length; i++){
            this.shiftPasspoints[i].connectList = []
          }
          this.setConnectList()
          
          let passPoints = []
          let noStopPoints = []
          let stopPoints = []
          this.pointDataList = []

          // 画点
          new Promise((resolve, reject) => {
            // let st = 1
            for (let shiftPasspoint of this.shiftPasspoints) {
              if (shiftPasspoint.stopFlag === true && shiftPasspoint.displayFlag === 1) {
                // st += 1
                this.pointDataList.push({
                  stationId: shiftPasspoint.listIndex,
                  stationLat: shiftPasspoint.stationLat,
                  stationLng: shiftPasspoint.stationLng,
                  icon: shiftPasspoint.icon,
                  labelClass: shiftPasspoint.labelClass
                })
                stopPoints.push({
                  shiftId: null,
                  label: null,
                  lat: shiftPasspoint.stationLat,
                  lng: shiftPasspoint.stationLng,
                  // 点的图标
                  icon: shiftPasspoint.icon,
                  iconSize: {
                    width: 20,
                    height: 20
                  }
                })
              } else if(shiftPasspoint.stopFlag === false && shiftPasspoint.displayFlag === 1){
                noStopPoints.push({
                  shiftId: null,
                  label: null,
                  lat: shiftPasspoint.stationLat,
                  lng: shiftPasspoint.stationLng,
                  // 点的图标
                  icon: shiftPasspoint.icon,
                  iconSize: {
                    width: 20,
                    height: 20
                  }
                })
                stopPoints.push({
                  shiftId: null,
                  label: null,
                  lat: shiftPasspoint.stationLat,
                  lng: shiftPasspoint.stationLng,
                  // 点的图标
                  icon: shiftPasspoint.icon,
                  iconSize: {
                    width: 20,
                    height: 20
                  }
                })
              }
              passPoints.push({
                lat: shiftPasspoint.stationLat,
                lng: shiftPasspoint.stationLng
              })
            }
            resolve()
          }).then(() => {
            this.$refs.gMap.initializeGoogleMap().then(() => {
              this.$refs.gMap.map.setZoom(14)
              this.centerPoint = {
                lat: (this.pointDataList[0].stationLat + this.pointDataList[this.pointDataList.length - 1].stationLat) / 2,
                lng: (this.pointDataList[0].stationLng + this.pointDataList[this.pointDataList.length - 1].stationLng) / 2
              }
              this.$refs.gMap.map.setCenter(this.centerPoint)
              let imgSize = {width: 45, height: 60}
              let labelAnchor = {width: 22, height: 50}
              this.$refs.gMap.addMark(imgSize, this.labelClass, labelAnchor)
              for (let noStopPoint of noStopPoints) {
                this.$refs.gMap.addSingleMaker(noStopPoint)
              }
              // this.$refs.gMap.drawLine(passPoints)
              // this.$refs.gMap.plannRoute(passPoints)
              this.$refs.gMap.plannRoute(stopPoints)
              // })
            })
          })
          // 存入Session中
          sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
        })
        .catch(error => {
          console.log(error)
        })
      this.$axios.get('shift/selectInfoName').then(response => {
        sessionStorage.setItem('userInfo', JSON.stringify(response.data.userInfo))
      })
    },
    // 返回
    goback () {
      let from = this.$route.query.from
      switch (from) {
        case 'VehicleList':
          this.$router.push({name: 'VehicleList', query: {currentDate: this.currentDate}})
          break
        case 'MovementShift':
          this.$router.push({name: 'MovementShift', query: {currentDate: this.currentDate.substr(0, 6)}})
          break
        case 'DriverScheduleList':
          this.$router.push({name: 'DriverScheduleList'})
          break
        case 'OneDriverSchedule':
          this.$router.push({name: 'OneDriverSchedule'})
          break
      }
    },
    goToTable () {
      // ljc
      if (this.shiftInfo.businessStatus === 3) {
        // this.$router.push({ path: '/ShiftEndDetail' })
        if ((this.$route.query.from === 'DriverScheduleList') || (this.$route.query.from === 'OneDriverSchedule')) {
          this.$router.push({path: '/DriverShiftEndDetail'})
        } else if (this.$route.query.from === 'MovementShift') {
          this.$router.push({path: '/ShiftEndDetail', query: {from: 'MovementShift'}})
        } else if (this.$route.query.from === 'VehicleList') {
          this.$router.push({path: '/ShiftEndDetail', query: {from: 'VehicleList'}})
        }
      } else {
        // this.$router.push({ path: '/ShiftWithEventDetail' })
        if ((this.$route.query.from === 'DriverScheduleList') || (this.$route.query.from === 'OneDriverSchedule')) {
          this.$router.push({path: '/DriverShiftWithEventDetail'})
        } else if (this.$route.query.from === 'MovementShift') {
          this.$router.push({path: '/ShiftWithEventDetail', query: {from: 'MovementShift' ,transportKind: this.shiftInfo.transportKind, allConnectShiftsCanEdit: this.allConnectShiftsCanEdit}})
        } else if (this.$route.query.from === 'VehicleList') {
          this.$router.push({path: '/ShiftWithEventDetail', query: {from: 'VehicleList' ,transportKind: this.shiftInfo.transportKind, allConnectShiftsCanEdit: this.allConnectShiftsCanEdit}})
        }
      }
    },
    HHmm (str) {
      if (str === null || str === '') {
        return ''
      }
      return DateUtil.hourMin(str)
    },
    hhmm (date) {
      if (date) {
        let hour = parseInt(date.substr(0, 2))
        if (hour < 10 && hour > 0) {
          return date.substr(1, 4)
        }
      }
      return date
    },
    // 获取乘客名
    getPassengerNameObj (reserveId) {
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.reserveId === reserveId) {
          if (this.shiftInfo.shiftFlag === 0) {
            return {name: reservation.lastName + ' ' + reservation.firstName, nameKana: reservation.lastNameKana + ' ' + reservation.firstNameKana, reservationNote: reservation.note}
          } else {
            return {name: reservation.lastName + ' ' + reservation.firstName, nameKana: reservation.lastNameKana + ' ' + reservation.firstNameKana, reservationNote: reservation.note}
          }
        }
      }
      return {}
    },
    getPassengerAddressObj (reserveId) {
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.reserveId === reserveId) {
          if (this.shiftInfo.shiftFlag === 0) {
            switch (reservation.startPlaceType) {
              case 1:
                return {address: reservation.homeAddress, stationId: '', lat: reservation.homeLat, lng: reservation.homeLng}
              case 2:
                return {address: reservation.startStationAddress, stationId: reservation.startStationId, lat: reservation.startStationLat, lng: reservation.startStationLng}
              default:
                return {address: reservation.startPlaceName, stationId: '', lat: reservation.startPlaceLat, lng: reservation.startPlaceLng}
            }
          } else {
            switch (reservation.arrivePlaceType) {
              case 1:
                return {address: reservation.homeAddress, stationId: '', lat: reservation.homeLat, lng: reservation.homeLng}
              case 2:

                return {address: reservation.arriveStationAddress, stationId: reservation.arriveStationId, lat: reservation.arriveStationLat, lng: reservation.arriveStationLng}
              default:
                return {address: reservation.arrivePlaceName, stationId: reservation.startStationId, lat: reservation.arrivePlaceLat, lng: reservation.arrivePlaceLng}
            }
          }
        }
      }
      return {}
    },
    // 判断是否停车
    isStop (stationId) {
      // 上车乘客
      let startPassengers = []
      // 下车乘客
      let arrivePassengers = []
      let stopFlag = false
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        // 获取停留所上车人
        if (reservation.startStationId === stationId) {
          startPassengers.push({reserveId: reservation.reserveId, name: reservation.lastName + ' ' + reservation.firstName})
          stopFlag = true
        }
        if (reservation.arriveStationId === stationId) {
          arrivePassengers.push({reserveId: reservation.reserveId, name: reservation.lastName + ' ' + reservation.firstName})
          stopFlag = true
        }
      }
      return {stopFlag: stopFlag, startPassengers: startPassengers, arrivePassengers: arrivePassengers}
    },
    detailed (shiftPasspoint) {
      // 图标样式
      let vehiclePoint = {
        label: shiftPasspoint.listIndex,
        lat: shiftPasspoint.stationLat,
        lng: shiftPasspoint.stationLng,
        icon: shiftPasspoint.icon
      }
      // 传数据
      this.$refs.saveWindowDiv.viewModel = shiftPasspoint
      this.$refs.saveWindowDiv.title = '運行便に戻る'
      var center = {
        lat: shiftPasspoint.stationLat,
        lng: shiftPasspoint.stationLng
      }
      // 设置中心点
      this.$refs.saveWindowDiv.centerPoint = center
      this.$refs.saveWindowDiv.markPosition = vehiclePoint
      // 设置缩放
      this.$refs.saveWindowDiv.zoom = 16
      // 加载地图
      this.$refs.saveWindowDiv.initiGoogleMap(shiftPasspoint.labelClass)
    },
    commitServer () {
      if (JSON.parse(sessionStorage.getItem('shiftReservation')) != null) {
        this.shiftReservation = JSON.parse(sessionStorage.getItem('shiftReservation'))
      }
      this.shiftReservation.flag = 'add'
      sessionStorage.setItem('shiftReservation', JSON.stringify(this.shiftReservation))
      if (this.shiftInfo.rePassengerNumber < this.shiftInfo.passengerNumber) {
        this.$router.push({
          path: '/passengerReservation',
          name: 'passengerReservation'
        })
      }
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        this.showDialog = false
        this.$router.push({
          path: '/passengerReservation',
          name: 'passengerReservation'
        })
      }).catch(() => {
        this.showDialog = false
      })
    },
    // “运行未定、运行予定”状态判断
    checkShiftMovementStatus (shiftInfo) {
      let movementStatus = ''
      // 「運行未定」の便は「未公開」状態 ＋ 「公開中」で乗客予約が0人の場合
      if ((shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 0)) {
        movementStatus = this.shiftMovementStatus1[3]
      } else if (shiftInfo.businessStatus === 1 && shiftInfo.openFlag === 1) {
        movementStatus = this.shiftMovementStatus1[0]
      } else if (shiftInfo.coercionStopFlag === 1) {
        movementStatus = this.shiftMovementStatus1[4]
      } else {
        movementStatus = this.shiftMovementStatus1[shiftInfo.businessStatus - 1]
      }
      return movementStatus
    },
    // 检查业务状态
    checkStatus (shiftInfo) {
      if (shiftInfo === undefined) {
        return 0
      }
      if (!shiftInfo.businessStatus || shiftInfo.businessStatus === 1) {
        if (shiftInfo.openFlag === 0) {
          return 0
        } else {
          return 1
        }
      } else if (shiftInfo.coercionStopFlag === 1) {
        return 4
      } else {
        return shiftInfo.businessStatus
      }
    },
    showShiftDetailDialog (e) {
      if (this.shiftInfo.rePassengerNumber > 0) {
        this.showMessDialog = true
        e.stopPropagation()
        this.$refs.messDialog.confirm().then(() => {
          this.showMessDialog = false
        }).catch(() => {
          this.showMessDialog = false
        })
      } else {
        this.shiftDetail = Object.assign({}, this.shiftInfo)
        this.shiftDetail.moveShiftTime = this.tmpMoveShiftTime
      }
    },
    changeOpenFlag (openFlag) {
      this.shiftInfo.openFlag = openFlag
      sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
    },
    // 区域外対応
    // 親便IDを取得
    getParentShiftId (){
      console.log("getParentShiftId")
      let parentShiftId
      if(this.shiftInfo.parentShiftId == '' || this.shiftInfo.parentShiftId == null){
        parentShiftId = this.shiftInfo.shiftId
      }else{
        parentShiftId = this.shiftInfo.parentShiftId
      }
      console.log(parentShiftId)
      return parentShiftId
    },

    // 停留所が接続されている便を取得し、停留所一覧と紐付ける
    setConnectList () {
      console.log('setConnectList')
      console.log(this.shiftInfo)
      let parentShiftId = this.getParentShiftId()

      // 便一覧を取得
      let shiftList = []
      this.$axios.get('shift/queryShiftInfoListByParentShiftId', {params: {parentShiftId: parentShiftId}}).then(response => {
        let shiftInfoList
        let shift = {}
        console.log("queryShiftInfoListByParentShiftId")
        console.log(response.data.shiftInfoList)
        shiftInfoList = response.data.shiftInfoList
        for (let shiftInfoTemp of shiftInfoList) {
          shift = {}
          shift.shiftId = shiftInfoTemp.shiftId
          shift.shiftTitle = shiftInfoTemp.title
          shiftList.push(shift)

          // 接続便の状態チェック
          if(shiftInfoTemp.businessStatus == 2){
            console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務開始」です")
            this.allConnectShiftsCanEdit = false
          }else if(shiftInfoTemp.businessStatus == 3){
            console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務終了」です")
            this.allConnectShiftsCanEdit = false
          }
        }
        console.log("shiftList")
        console.log(shiftList)

        // 接続をすべて取得し、停留所一覧と紐付ける
        this.$axios.get('shift/queryShiftConnectList', {params: {parentId: parentShiftId}}).then(response => {
          console.log(response.data)
          for(let i=0; i < response.data.shiftConnectList.length; i++){
            let shiftConnectTemp = {
                frontShiftConnect: {
                  shiftId: '0000',
                  connectSourceShiftId: '0000',
                  stationId: '',
                  connectSourceStationId: '',
                  stationTime: '',
                  connectSourceStationTime: '',
                  stationUseTime: 0,
                  errorMessage: '',
                  timeError: 0
                },
                shiftConnect: {
                },
              }
            shiftConnectTemp.frontShiftConnect = response.data.shiftConnectList[i]
            shiftConnectTemp.shiftConnect = response.data.shiftConnectList[i]
            this.shiftConnectList.push(shiftConnectTemp)
          }
          this.isLoading = false

          let connect = {}
          let duplicateFlag = false
          for(let i = 0; i < this.shiftPasspoints.length; i++){
            this.shiftPasspoints[i].connectList = []
            for(let j= 0; j < this.shiftConnectList.length; j++){
              duplicateFlag = false
              // 接続一覧からページ内の停留所と一致する停留所を探し、その接続の便名とIDを取得する
              // 接続元の場合
              if(this.shiftPasspoints[i].stationId == this.shiftConnectList[j].frontShiftConnect.connectSourceStationId){
                connect = {}
                connect.shiftId = this.shiftConnectList[j].frontShiftConnect.shiftId
                // 便名取得
                for(let k = 0; k < shiftList.length; k++){
                  if(shiftList[k].shiftId == connect.shiftId){
                    connect.shiftTitle = '接続先 ' + shiftList[k].shiftTitle
                  }
                }
                // 重複チェック
                for(let j = 0; j < this.shiftPasspoints[i].connectList.length; j++){
                  if(this.shiftPasspoints[i].connectList[j].shiftId == connect.shiftId){
                    duplicateFlag = true 
                  }
                }
                if(!duplicateFlag){
                  this.shiftPasspoints[i].connectList.push(connect)
                }
              }
              // 接続先の場合
              if(this.shiftPasspoints[i].stationId == this.shiftConnectList[j].frontShiftConnect.stationId){
                connect = {}
                connect.shiftId = this.shiftConnectList[j].frontShiftConnect.connectSourceShiftId
                // 便名取得
                for(let k = 0; k < shiftList.length; k++){
                  if(shiftList[k].shiftId == connect.shiftId){
                    connect.shiftTitle = '接続元 ' + shiftList[k].shiftTitle
                  }
                }
                // 重複チェック
                for(let j = 0; j < this.shiftPasspoints[i].connectList.length; j++){
                  if(this.shiftPasspoints[i].connectList[j].shiftId == connect.shiftId){
                    duplicateFlag = true 
                  }
                }
                if(!duplicateFlag){
                  this.shiftPasspoints[i].connectList.push(connect)
                }
              }
            }
          }
          // 描画更新
          this.shiftPasspoints.splice(0,this.shiftPasspoints)
          console.log(this.shiftPasspoints)
        })
      })
    },

    // 接続便の詳細ボタンクリック時の動作
    goToConnectShift(index){
      if(this.shiftPasspoints[index].shiftId != null || this.shiftPasspoints[index].shiftId != ''){
        this.$router.push({ path: '/MovementShiftDetail', query: {shiftId: this.shiftPasspoints[index].shiftId,from: this.$route.query.from} })
      }
    }
  }
}
</script>

<template>
  <MainLayout>
    <div class="body">
      <div class="row clearfix header">
        <div class="col-md-2 column headerleft F1-R-19">
          <input type="button" :value="backName" @click="goback" />
        </div>
        <div class="col-md-8 column headermiddle">
          <!--不同页面路由过来header部分显示不同，根据路由选择 -->
             <b v-if="this.$route.query.from==='MovementShift'||this.$route.query.from==='VehicleList'" class="F3-M-27">{{shiftInfo.moveShiftTime}}</b>
             <!-- <b v-if="this.$route.query.from==='DriverScheduleList'||this.$route.query.from==='OneDriverSchedule'" class="F3-M-27">{{shiftInfo.driverName}} (スケジュール)</b> -->
          <div v-if="this.$route.query.from==='DriverScheduleList'||this.$route.query.from==='OneDriverSchedule'" class="F3-M-27 flex" style="width:600px;margin:0 auto">
             <span style="display:block;" class="member-name" :title="driverNameTitle">{{shiftInfo.driverName}} (スケジュール)</span>
          </div>
        </div>
      </div>
      <hr class="hrheader" v-show="this.$route.query.from==='DriverScheduleList'||this.$route.query.from==='OneDriverSchedule'">
      <div class="col-md-12 column F3-M-27" v-show="this.$route.query.from==='DriverScheduleList'||this.$route.query.from==='OneDriverSchedule'">{{shiftInfo.moveShiftTime}}</div>
      <div class="col-md-12 column" style="height: calc(100% - 90px);">
        <div class="row clearfix" style="height: 100%;">
          <div class="col-md-5 column homeLeft slider">
            <div class="homeleftdetail">
              <!-- title -->
              <div class="clearfix homeTitle" :class="titleBgs[shiftStatus]">
                <div class="col-md-9 column left-content F2-M-20">
                  <div class="shift-title">
                    <img src="../../assets/icon/transport_kind0.png" style="height: 32px;width:32px;" v-if="shiftInfo.transportKind=='0'">
                    <img src="../../assets/icon/transport_kind1.png" style="height: 32px;width:32px;" v-if="shiftInfo.transportKind=='1'">
                    <img src="../../assets/icon/app_use.png" style="height: 32px;width:32px;" v-if="shiftInfo.routeType=='1'">
                    <img src="../../assets/icon/app_dontuse.png" style="height: 32px;width:32px;" v-if="shiftInfo.routeType=='2'">
                    <!-- <img src="../../assets/icon/transport_kind1.png" style="height: 32px;width:32px;"> -->
                    <!-- <img src="../../assets/icon/app_dontuse.png" style="height: 32px;width:32px;"> -->
                    {{shiftInfo.title}}
                  </div>
                </div>
                <div class="col-md-3 column right-content" style="display: flex;flex-direction: column;align-items: center;">
                  <div class="clearfix rightItem">
                    <!--从MoveShift、DriverScheduleList、OneDriverSchedule传过来显示不同 -->
                    <!-- 状态 -->
                    <div v-if="this.shiftInfo.transportKind === 0">
                      <a href="#modal-container-regular-detail" v-if="shiftStatus==0||shiftStatus==1" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                        <button class="btn status-btn F2-M-15-m"
                        :class="statusBtnBgs[shiftStatus]"
                        :style="shiftStatus==0?'color:rgb(149,149,149)':'color:#fff'"
                        v-if="this.$route.query.from==='MovementShift'||this.$route.query.from==='VehicleList'"
                        @click="showShiftDetailDialog"
                        onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                          {{shiftMovementStatus[shiftStatus]}}
                        </button>
                      </a>
                      <a v-else>
                        <button class="btn status-btn F2-M-15-m"
                          :class="statusBtnBgs[shiftStatus]"
                          :style="shiftStatus==0?'color:rgb(149,149,149)':'color:#fff'"
                          v-if="this.$route.query.from==='MovementShift'||this.$route.query.from==='VehicleList'"
                          >
                            {{shiftMovementStatus[shiftStatus]}}
                          </button>
                      </a>
                    </div>
                    <div v-else class="btn-nochange">
                      <div v-if="shiftStatus==0||shiftStatus==1">
                        <div class="btn status-btn F2-M-15-m"
                        :class="statusBtnBgs[shiftStatus]"
                        :style="shiftStatus==0?'color:rgb(149,149,149)':'color:#fff'"
                        v-if="this.$route.query.from==='MovementShift'||this.$route.query.from==='VehicleList'"
                        onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                          {{shiftMovementStatus[shiftStatus]}}
                        </div>
                      </div>
                      <div v-else>
                        <div class="btn status-btn F2-M-15-m"
                          :class="statusBtnBgs[shiftStatus]"
                          :style="shiftStatus==0?'color:rgb(149,149,149)':'color:#fff'"
                          v-if="this.$route.query.from==='MovementShift'||this.$route.query.from==='VehicleList'"
                          >
                            {{shiftMovementStatus[shiftStatus]}}
                          </div>
                      </div>
                    </div>

                    <button class="btn status-btn status-btn-bg3 F2-M-15" v-if="this.$route.query.from==='DriverScheduleList'||this.$route.query.from==='OneDriverSchedule'">
                      {{checkShiftMovementStatus(shiftInfo)}}
                    </button>
                  </div>
                  <div class="clearfix rightItem F2-M-20">
                    <div>
                      {{hhmm(shiftInfo.startTime)}}発
                    </div>
                  </div>
                </div>
              </div>
              <!-- 内容 -->
              <div class="homeContent" :class="contentBgs[shiftStatus]">
                <div class="clearfix homefrist">
                  <div class="col-md-9 column left-content">
                    <div class="col-md-3 column F3-M-16" style="padding:0px">[ドライバー]</div><div class="col-md-9 column F3-M-22 driver-name">&nbsp;{{shiftInfo.driverLastName}}&nbsp;{{shiftInfo.driverFirstName}}</div>
                  </div>
                  <div class="col-md-3 column right-content" style="display: flex;align-items: center;justify-content: center;">
                    <button class="btn detail-btn F2-M-16" style="border:0px" @click="goToTable">詳細</button>
                  </div>
                </div>
                <div class="clearfix homeContentdiv" v-if="shiftInfo.vehicleId===null">
                  <div class="col-md-3 column div-style F3-R-17">
                      車両 : 未定
                      <img class="excalmatory-mark" src="@/assets/excalmatory-mark.png">
                  </div>
                </div>
                <div class="clearfix homeContentdiv" v-else>
                  <div class="col-md-3 column div-style F3-R-17">
                    車両ID : {{shiftInfo.displayVehicleId}}
                  </div>
                  <div class="col-md-3 column vehicle-name F3-R-17" :title="shiftInfo.vehicleName">
                      車両 : {{shiftInfo.vehicleName}}
                  </div>
                  <div class="col-md-3 column div-style F3-R-17">
                    定員 : {{shiftInfo.passengerNumber}}名
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix" style="height:0px"></div>
            <!-- 添加预约 -->
            <a @click="commitServer" data-toggle="modal">
              <div class="clearfix reserve-div" v-if="showReservationDiv">
                <div class="col-md-2 column add-reserve-div">
                  <img class="add-reserve" src="@/assets/operation_list/add_ride_member.png" />
                </div>
                <div class="col-md-2 column reserve-blank">
                </div>
                <div class="col-md-6 column reserve-title F2-M-20">
                  乗客予約
                </div>
                <div class="col-md-2 column reserve-person">
                  <div class="person-div">
                    <!-- <div v-if="shiftInfo.isOverLoad || shiftInfo.rePassengerNumber>3">
                      <img src="@/assets/operation_list/ride_status4_big.png"/>
                    </div>
                    <div v-else>
                      <img v-if="shiftInfo.rePassengerNumber===0" src="@/assets/operation_list/ride_status1_big.png"/>
                      <img v-if="shiftInfo.rePassengerNumber===1" src="@/assets/operation_list/ride_status2_big.png"/>
                      <img v-if="shiftInfo.rePassengerNumber===2" src="@/assets/operation_list/ride_status3_big.png"/>
                      <img v-if="shiftInfo.rePassengerNumber===3" src="@/assets/operation_list/ride_status4_big.png"/>
                    </div> -->
                    {{shiftInfo.rePassengerNumber}}/{{shiftInfo.passengerNumber}}
                  </div>
                </div>
              </div>
            </a>
            <!-- 经由地 -->
            <div class="clearfix list-item bgc5" v-for="(shiftPasspoint,index) in shiftPasspoints" :key="index"
            style="height: fit-content; position:relative;">
              <div class="list-item-index">
                <div class="list-bar bgc6" :class="{'list-bar-s':index===0,'list-bar-g':index===shiftPasspoints.length-1}" ></div>
                <!-- index -->
                <div class="list-index">
                  <!-- 圆圈 -->
                  <div class="F2-R-20" :class="[(shiftPasspoint.listIndex==='S'||shiftPasspoint.listIndex==='G')&&shiftPasspoint.officeFlag===1?'radio-office':'radio']" v-if="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1" style="z-index:99">
                      <span class="radio-index">{{shiftPasspoint.listIndex}}</span>
                  </div>
                  <div class="F2-R-20 radio-none" v-else style="z-index:99">

                  </div>
                  <!-- 竖线 -->
                  <!-- <div class="columnSty bgc6" :style="{top:index===0?'50%':'',bottom:index===shiftPasspoints.length-1?'50%':''}" ></div> -->
                </div>
              </div>
              <div class="list-item-main">
                <div :href="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1?'#modal-container-station-dialog':'javascript:void(0)'" class="list-item-detail" @click="detailed(shiftPasspoint)" data-toggle="modal">
                  <!-- 预定时间 -->
                  <div class="col-md-2 column list-time">
                    <span :class="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1?'F6-R-24':'F8-R-24'">{{HHmm(shiftPasspoint.estimateTime)}}</span>
                  </div>
                  <!-- 内容 -->
                  <div class="col-md-6 column list-content">
                    <div class="row clearfix">
                      <div class="col-md-12 column list-name"
                      :class="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1?'F1-R-20':'F7-R-20'"
                      :title="shiftPasspoint.name">
                          <img src="../../assets/icon/office_flag1.png" style="margin:-2px 4px 0 0; height: 32px;width:32px;" v-if="shiftPasspoint.officeFlag=='1'">
                          <div style="margin:-2px 4px 0 0; height: 32px;width:32px;" v-else></div>
                        {{shiftPasspoint.name}}
                      </div>
                    </div>
                    <div class="row clearfix">
                      <div class="col-md-12 column list-address"
                      :class="shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1?'F3-R-15':'F7-R-15'"
                      :title="shiftPasspoint.address">
                        {{shiftPasspoint.address}}
                      </div>
                    </div>
                    <!-- 停留所显示预约人 -->
                    <div class="row clearfix list-station-passenger" v-if="shiftPasspoint.showPassengers">
                      <div class="col-md-12 column F3-R-15 tooLong">
                          乗車者:<span v-for="(passenger,k) in shiftPasspoint.startPassengers" :key="k" class="F3-R-15">{{passenger.name}}<span v-if="k!=shiftPasspoint.startPassengers.length-1">、</span></span>
                      </div>
                    </div>
                  </div>
                  <!-- 实际到达时间 -->
                  <div class="col-md-2 column list-right" v-if="shiftPasspoint.actualTime!=null&&shiftPasspoint.actualTime!=''&&shiftPasspoint.stopFlag && shiftPasspoint.displayFlag === 1">
                    <div class="clearfix">
                      <div class="col-md-12 column arrive-status">
                        <div v-if="index==0" class="list-status bgc1">出発</div>
                        <div v-else class="list-status bgc1">到着</div>
                      </div>
                    </div>
                    <div class="clearfix">
                      <div class="col-md-12 column list-true-time">
                        {{HHmm(shiftPasspoint.actualTime)}}
                      </div>
                    </div>
                  </div>
                  
                </div>
                <!-- 接続一覧 -->
                <div class="list-connect" v-if="shiftPasspoint.connectList.length > 0">
                  <div class="list-connect-title">
                    乗り換えあり
                  </div>
                  <div class="list-connect-select">
                    <select class="selectstyles selectImg" @click.stop v-model="shiftPasspoint.shiftId">
                      <option :value="connect.shiftId" :key="index" v-for="(connect, index) in shiftPasspoint.connectList">
                        {{connect.shiftTitle}}
                      </option>
                    </select>
                  </div>
                  <div class="detail-div">
                      <button class="btn detail-btn F2-M-16" :disabled="shiftPasspoint.shiftId==null" @click.stop="goToConnectShift(index)">詳細</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-7 column homeRight">
            <googleMap ref="gMap" :center-point="centerPoint" :map-id="mapId" :point-list="pointDataList" />
          </div>
        </div>
      </div>
      <MovementDetailedConfirm ref="saveWindowDiv"></MovementDetailedConfirm>
      <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
      <v-dialog v-show="showMessDialog" :dialog-option="dialogMessOption" ref="messDialog"></v-dialog>
      <movement-shift-window-mask :shift="shiftDetail" @changeOpenFlag="changeOpenFlag"></movement-shift-window-mask>
    </div>
  </MainLayout>
</template>

<style scoped>
@import "../../assets/css/C00.css";
.radio {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid #48a3be;
  background-color: #48a3be;
}
.radio-office {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid #48a3be;
  background-color: #FFF;
  color: #48a3be!important;
}
.radio-none {
  width: 36px;
  height: 36px;
  background: url('../../assets/operation_list/non_stop_point1.png')
}
.radio-index{
  display: block;
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-weight: bold!important;
}


.name-strong {
  font-size: 20px;
}
.hrheader {
  background-color: rgb(148, 148, 148);
  margin-top: -10px;
  height: 1px;
  width: 600px;
}
.vehicle-span{
  font-size: 15px;
}
.text-color1{
  color:rgb(162, 162, 162)
}
.text-color2{
  color:#333
}
.add-reserve-div{
  padding: 0px;
  width: 15%;
  height: 100%;
  position: relative;
}
.add-reserve{
  height: 40px;
  width: 40px;
  position: absolute;
  top:50%;
  left:50%;
  margin-top: -20px;
  margin-left: -20px;
}
.reserve-blank{
  padding: 0px;
  width: 15%;
}
.reserve-title{
  line-height: 75px;
  padding: 0px;
  width: 50%;
  text-align: left;
  color: #fff
}
.reserve-person{
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.person-div{
  font-size: 24px;
}
.list-item{
  border-bottom: rgb(178,178,178) solid 1px;
  border-top: rgb(255,255,255) solid 1px;
  background: #DCDCDC;
  margin: 0px auto;
  padding: 5px 0;
  height: 80px;
  display: flex;
  /* flex-direction: column; */
}

.list-item-index{
  width: 15%;
  position: relative;
}
.list-item-main{
  width: 85%;
  cursor:pointer;
  display: flex;
  flex-direction: column;
}
/* 经由地编号 */
.list-index {
  font-size: 20px;
  padding: 0px;
  /* width: 15%; */
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.list-bar {
  margin-top: -10px;
  position: absolute;
  left: calc(50% - 2px);
  height: calc(100% + 15px);
  width: 4px;
}
.list-bar-s {
  top: 50%;
  height: calc(50% + 15px);
}
.list-bar-g {
  height: calc(50% + 15px);
}

.tooLong{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-time{
  padding: 0px;
  font-size: 24px;
  width: 18%;
  height: 100%;
  display: flex;
  align-items: center;
}
.list-content{
  text-align: left;
  padding:0px;
  width: 57%;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.list-name{
  width: 95%;
  font-size: 24px;
  padding-right: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}
.list-address{
  font-size: 14px;
  padding-right: 0px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list-station-passenger{
  height: 33%;
  display: flex;
  align-items: center;
}
.list-right{
  padding: 0px;
  width: 25%;
}
.arrive-status{
  display: flex;
  align-content: center;
  justify-content: center;
}
.list-status{
  font-size: 15px;
  border: 0;
  height: 20px;
  width: 70%;
  border-radius: 10px;
  background: rgb(141, 141, 141);
  color: #fff;
  padding: 0px;
  margin: 7px 0;
}
.list-true-time{
  padding: 0px;
  font-size: 24px;
  height: 34px;
}

.header{
    margin-bottom: 2vh;
    height: 6vh;
    position: relative;
  }
.headerleft {
  margin-top: 20px;
  margin-left: 1.9%;
  width: 280px;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
  z-index: 999;
  /* border: solid 2px #ccc;
  border-radius: 20px; */
}
.headerleft  input {
  float: left;
  border: none;
  background: none;
  height: 40px;
  text-align: left;
  width: 100%;
  text-indent: 30px;
}
.headermiddle {
  margin-top: 20px;
  font-size: 24px;
  position: absolute;
  width: 100%;
}
.body{
  display:flex;
  flex-direction:column;
  height: calc(100% - 100px);
}
.map_container {
  margin-top: 50px;
  width: 100%;
  height: 580px;
}
.homeLeft {
  width: 39%;
  /* height: 72vh; */
  height: calc(100% - 20px);
  /* 规定元素生成的框的类型 */
  display: inline-block;
  padding-right: 20px;
  margin-top: 10px;
}
.homeTitle{
  background: #48a3be;
  color: #ffffff;
  height: 80px;
  padding: 0 9px;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.left-content{
  padding: 0px;
  width: 80%;
  text-align: left;
  display: flex;
  align-items: center;
}
.shift-title{
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 85%;
}
.driver-name{
  padding: 0px;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.right-content{
  width: 20%;
  padding: 0px;
  height: 100%;
}
.rightItem{
  height: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.div-style{
  padding: 0px;
}
.vehicle-name{
  width:40%;
  white-space:nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 0px;
}
.homeTip{
  background:rgb(210, 210, 210);
  height: 40px;
  font-size: 18px;
}
.status-btn{
  float: right;
  font-size: 15px;
  border: 0;
  height: 28px;
  width: 84px;
  border-radius: 13px;
  /* background: rgb(141, 141, 141); */
  margin: 7px;
}
/* 公開中 */
.status-btn-bg1{
  padding-left: 6px;
  text-align: left;
  color: #fff;
  background: url(../../assets/button/toggle_sw1.png);
}
/* 非公開 */
.status-btn-bg2{
  padding-right: 6px;
  text-align: right;
  color: #000;
  background: url(../../assets/button/toggle_sw2.png);
}
/* 运行中和终了 */
.status-btn-bg3{
  color: #fff;
  background: url(../../assets/button/toggle_sw3.png);
}

.btn-nochange{
  pointer-events: none;
}
/* 公開中 */
.btn-nochange .status-btn-bg1{
  /* padding-right: 0; */
  text-align: center;
  color: #fff;
  background: url(../../assets/button/toggle_sw3.png);
}
/* 非公開 */
.btn-nochange .status-btn-bg2{
  /* padding-right: 0; */
  text-align: center;
  color: #000;
  background: url(../../assets/button/toggle_sw4.png);
}
/* 运行中和终了 */
.btn-nochange .status-btn-bg3{
  color: #fff;
  background: url(../../assets/button/toggle_sw3.png);
}
.reserve-div{
  background:linear-gradient(rgb(112, 182, 202) 50%, rgb(72,163,190) 50%);
  color: #ffffff;
  border-radius: 5px;
  height: 75px;
  padding: 0;
  font-size: 18px;
  margin: 10px 0;
  cursor: pointer;
}
.homeContent{
  /* background: rgb(210, 210, 210); */
  height: 90px;
  font-size: 18px;
  text-align: left;
  padding: 0 7px;
  cursor:pointer;
  border: rgb(139, 139, 139) solid 2px;
}

.detail-btn{
  color:#fff;
  font-size:16px;
  height:32px;
  width:90px;
  border-radius:8px;
  float:right;
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
}
.homeContentdiv{
  font-size: 16px;
  height: 40%;
  display: flex;
  align-items: center;
}
.homefrist{
  height: 60%;
  border-bottom: 1px dashed rgb(148, 148, 148);
  display: flex;
  align-items: center;
}
.homeul{
  list-style-type: none;
  width: auto;
  background: #cecece;
  color: black;
  height: 80px;
  margin: 0px;
  padding: 0px;
  padding-top: 5px;
  text-align: left;
  padding-left: 5px;
}
.homeul li{
  float: left;
  padding-left: 20px;
}
.homeRight{
  padding-top: 10px;
  width: 61%;
  /* height: 72vh; */
  height: calc(100% - 10px);
}
.excalmatory-mark{
    height: 15px;
    margin-left: 5px;
}
.person-img{
  height:25px;
  width: 15px;
  margin-top: 5%;
}
a{
text-decoration:none;
}
/* 复用共同样式 */
.F2-M-15-m {
    font-family: 'Noto Sans CJK JP' !important;
    font-size: 15px !important;
    font-weight: 500 !important;
}
 @media screen and (max-device-width: 1480px) {
  .status-btn{
     font-size: 11px;
  }
  .vehicle-span{
    font-size: 13px;
  }
  .list-name{
    font-size: 20px;
  }
  .list-time{
    font-size: 20px;
  }
  .list-address{
    font-size: 10px;
  }
  .list-status{
    font-size: 11px;
  }
  .list-true-time{
    font-size: 20px;
  }
 }
 .member-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
<style lang="scss">
.selectstyles {
  font-size: 18px;
  border: solid 1px #ccc;
  border-radius: 10px;
  width: 100%;
  height: 40px;
  line-height: 20px;
  text-align: left;
  padding-left: 12px;
  padding-right:30px;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
  -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../../assets/dropselect.png") no-repeat scroll right center #FFF;
  // background: url("../../assets/dropselect.png") no-repeat scroll right center transparent;
}
.list-connect{
  display: flex;
  align-items: center;

  .list-connect-title{
    font-size: 12px;
    line-height: 40px;
    color: red;
  }

  .list-connect-select{
    margin-left: 4px;
    width: 60%;
  }
  select{
    width: 100%; 
  }
  .detail-div{
    margin: 0 auto 0 20px
  }
  .detail-btn{
    width: 60px;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/router/views/MovementShiftDetail.vue